import styled from 'styled-components';
import Check from '../../assets/v2/Hardware/TickHardware.svg';
import { H1, H2, SectionParent } from '../../components/StyledComponents';
import React from 'react';
import RequestDemoForm from './PricingForm';
import Companies from '../../assets/v2/Hardware/companies-white.png';

const SectionOne = styled(SectionParent)`
  background-repeat: no-repeat;
  background-color: #1b2341;
  /* padding-top: 6rem !important; */
  padding-bottom: 5rem;
  background-size: contain;
  @media (max-width: 1680px) and (min-width: 1440px) {
    padding-bottom: 5rem;
  }
  @media (max-width: 1440px) and (min-width: 768px) {
    padding-bottom: 5rem;
  }
  @media (max-width: 768px) {
    padding-top: 8rem !important;
  }
  @media (max-width: 520px) {
    padding-top: 2rem !important;
    padding-bottom: 5rem !important;
  }
  width: 100%;
  display: grid;
`;

const SectionItemContainer = styled.div`
  grid-template-columns: repeat(2, 1fr);
  padding-top: 5rem;
  padding-left: 5rem;
  padding-right: 3rem;
  display: grid;
  @media (max-width: 768px) {
    padding-left: 0rem;
    padding-top: 2rem;
    padding-right: 0;
  }
`;
const HeroImgContainerLeft = styled.img`
  width: fit-content;
  height: fit-content;
  justify-self: start;
  margin-top: 1rem;
  @media (max-width: 520px) and (min-width: 400px) {
    padding-left: 2.5em;
  }
  @media (max-width: 400px) {
    width: 100%;
  }
`;

const GridLeft = styled.div`
  grid-column: span 1;
  /* padding-left: 7rem; */
  max-width: 50%;
  position: relative;
  padding-left: 2rem;
  @media (max-width: 1100px) {
    padding-left: 0;
  }
  @media (max-width: 768px) {
    grid-column: span 2;
    padding-left: 0;
    max-width: 15rem;
    justify-self: center;
  }
`;

const FormComponentLeft = styled.div`
  display: grid;
  grid-column: span 1;
  align-content: center;
  grid-column: span 1;
  justify-items: start;
  width: 100%;

  @media (max-width: 768px) {
    border-radius: 8px 8px 0px 0px;
    grid-column: span 2;
  }
  @media (max-width: 520px) {
    padding: 0rem;
  }
  @media (max-width: 400px) {
    padding: 0rem 2rem;
  }
`;

const FormComponentLeftList = styled.ul`
  /* margin-left: 40px; */
  padding-left: 0em;
  list-style: none;
  @media (max-width: 768px) {
    display: none;
  }
`;

const FormComponentLeftListItem = styled.li`
  font-family: 'Nunito Sans', sans-serif;
  font-size: 18px;
  @media (max-width: 1024px) {
    font-size: 16px;
  }
  @media (max-width: 768px) {
    font-size: 14px;
  }
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #ffffff;
  background: url(${Check}) no-repeat;
  padding: 0.3em 0px 0.1em 30px;
  background-size: 18px;
  background-position-y: center;
  @media (max-width: 320px) {
    font-size: 12px;
  }
`;
const SectionOneTitle = styled(H1)`
  color: #ffffff;
  font-weight: bold;
  margin-bottom: 0;
  @media (min-width: 1440px) {
    font-size: 28px !important;
  }
  @media (max-width: 768px) {
    text-align: center !important;
  }
`;
const FromManufacturingT = styled(H2)`
  /* font-size: 18px; */
  line-height: 31px;
  color: #dbdfee;
  margin-top: 1rem;

  text-align: left;
  font-weight: normal;
  /* @media (max-width: 1700px) {
    font-size: 18px;
  }
  @media (max-width: 1440px) {
    font-size: 18px;
  } */
  @media (max-width: 1024px) {
    font-size: 18px;
  }
  @media (max-width: 768px) {
    font-size: 16px;
    width: 80%;
    margin-left: 10%;
    text-align: center;
  }
  margin-bottom: 1rem;
  font-family: 'Nunito Sans', sans-serif;
  @media (max-width: 520px) {
    /* margin-bottom: -50%; */
    width: 95%;
    padding: 0 3rem;
    line-height: 1.5;
    margin-left: 0;
  }
  @media (max-width: 375px) {
    padding: 0 1rem;
  }
`;
export default (props: any) => (
  <div>
    <SectionOne id="demo-form-hardware">
      <SectionItemContainer>
        <FormComponentLeft>
          <div>
            <SectionOneTitle
              style={{
                textAlign: 'left',
              }}
            >
              Choose the right hardware for your application
            </SectionOneTitle>
            <FromManufacturingT>
              Inadequate hardware can restrict the functionality of your system,
              resulting in a subpar experience and performance. Esper tackles
              this with:
            </FromManufacturingT>
            <FormComponentLeft>
              <FormComponentLeftList>
                <FormComponentLeftListItem>
                  Zero-Touch Provisioning
                </FormComponentLeftListItem>
                <FormComponentLeftListItem>
                  Ready-to-go Secure Remote Debugging
                </FormComponentLeftListItem>
                <FormComponentLeftListItem>
                  Remote View and Remote Control
                </FormComponentLeftListItem>
              </FormComponentLeftList>
              <HeroImgContainerLeft src={Companies} />
            </FormComponentLeft>
          </div>
        </FormComponentLeft>
        <GridLeft>
          <RequestDemoForm
            hardware={props.hardware}
            endState={`/hardware/submitted`}
            messages={props.messages}
          />
        </GridLeft>
      </SectionItemContainer>
    </SectionOne>
  </div>
);
